import script from "./ScreeningReportPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ScreeningReportPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ScreeningReportPreview.vue?vue&type=style&index=0&id=3b0b9666&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b0b9666"]])

export default __exports__